// Packages and components
import { useState } from 'react';

// Helpers and utilities
import axios from '@helpers/axios';

// Types and interfaces
import { dtos, shd } from '@shd/jslib/models';
import { strogging } from '@shd/jslib/infra';
import { ErrorMessage } from '@theme/theme.d';

import { MEVO_SINGLE, MEVO_MULTI } from '@constants/strings';

export const useCapture = () => {};

// @NOTE: Using the v1 API endpoint for now. NKS 2025-03-24.
export const useTeamCapture = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ErrorMessage | null>(null);
  const [captureList, setCaptureList] = useState<shd.TeamCapture[]>([]);

  const getTeamCapture = async (id: string) => {
    setLoading(true);
    try {
      const res = await axios.get<dtos.TeamCaptureGetResponse>(
        `api/team/${id}/capture`
      );
      setCaptureList(res.data.captureList);
      return res.data.captureList;
    } catch (err) {
      const message = `Error grabbing team capture for ID ${id}: ${err}`;
      strogging.log(message);
      setError({ message: message });
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, getTeamCapture, captureList };
};

export const usePointCapture = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<ErrorMessage | null>(null);

  const pointCapture = async (
    targetTeamId: string,
    capture: shd.TeamCapture
  ) => {
    const newCapture = { ...capture };
    newCapture.targetTeamId = targetTeamId;
    setLoading(true);
    try {
      const response = await axios.put(`/api/capture/${capture._id}`, {
        captureInfo: newCapture,
        force: true,
      });
      return response.data;
    } catch (err) {
      const message = `Error pointing capture ${capture._id}: ${err}`;
      strogging.log(message);
      setError({ message: message });
    } finally {
      setLoading(false);
    }
  };

  const updateMevoType = async (
    capture: shd.TeamCapture,
    mevoType: typeof MEVO_SINGLE | typeof MEVO_MULTI
  ) => {
    const newCapture = { ...capture };
    newCapture.equipCamera = mevoType;
    setLoading(true);
    try {
      const response = await axios.put(`/api/capture/${newCapture._id}`, {
        captureInfo: newCapture,
      });
      return response.data;
    } catch (err) {
      const message = `Error updating Mevo type for capture ${newCapture._id}: ${err}`;
      strogging.log(message);
      setError({ message: message });
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, pointCapture, updateMevoType };
};
